import React, { Component } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import { getAlerts, getUsers, removeQualificationAlert } from "./actions";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    Typography,
    Button
} from "@material-ui/core";
import { Delete as DeleteIcon } from "@material-ui/icons";

class QualificationsAlertWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteModal: false
        };
        props.getAlerts();
        props.getUsers();
    }
    render() {
        const { qualificationAlerts } = this.props;

        return (
            <>
             <ReactToPrint
                        trigger={() => (
                            <Button  color="primary"
                            variant="contained"
                            style={{ background: "#0188cc" }}>
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                <Table padding="dense" style={{ width: "100%" }} ref={el => (this.componentRef = el)}>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell text="User Name" />
                            <TableHeadCell text="Category" />
                            <TableHeadCell text="Title" />
                            <TableHeadCell text="Exp. Date" />
                            <TableHeadCell text="Time Left" />
                            <TableHeadCell text="Actions" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {qualificationAlerts &&
                            Object.keys(qualificationAlerts).map((e, i) => {
                                return qualificationAlerts[e].map((f, j) => {
                                    return (
                                        <>
                                            <TableRow key={j}>
                                                <TableBodyCell
                                                    text={f.user_name}
                                                />
                                                <TableBodyCell
                                                    text={
                                                        f.qualification_category
                                                    }
                                                />
                                                <TableBodyCell
                                                    text={f.qualification_title}
                                                />
                                                <TableBodyCell
                                                    text={
                                                        f.qualification_exp_date
                                                    }
                                                />
                                                <TableBodyCell
                                                    text={f.days + " days"}
                                                />
                                                <TableCell>
                                                    <IconButton
                                                        style={{
                                                            color: "red",
                                                            border:
                                                                "1px solid red",
                                                            margin: "9px"
                                                        }}
                                                        onClick={() => {
                                                            this.props.removeQualificationAlert(
                                                                e
                                                            );
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    );
                                });
                            })}
                    </TableBody>
                </Table>
            </>
        );
    }
}

const TableBodyCell = ({ text = "N/A", style }) => {
    return (
        <TableCell style={style}>
            <Typography variant="body2">{text}</Typography>
        </TableCell>
    );
};
const TableHeadCell = ({ text }) => {
    return (
        // <StyledTableCell>
        <TableCell>
            <Typography variant="body2">
                <b>{text}</b>
            </Typography>
        </TableCell>
        // </StyledTableCell>
    );
};

export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectQualificationAlerts,
            getRequesting,
            selectUserInfo
        } = selectors;
        return {
            qualificationAlerts: selectQualificationAlerts(store),
            requesting: getRequesting(store),
            users: selectUserInfo(store)
        };
    },
    { getAlerts, getUsers, removeQualificationAlert }
)(QualificationsAlertWidget);
